import gsap from 'gsap'
import ScrollTrigger from 'gsap/dist/ScrollTrigger'

const featuredBlock = {
  init(): void {
    gsap.registerPlugin(ScrollTrigger)

    document.querySelectorAll<HTMLElement>('.featured-block').forEach((target: HTMLElement) => {
      this.handleFeaturedBlock(target)
    })
  },

  handleFeaturedBlock(target): void {
    const el = {
      block: target,
      photo: {
        circle: target.querySelector('.featured-block__picture-column--circle .featured-block__picture-container'),
        main: target.querySelector('.featured-block__picture-column--main .featured-block__picture-container'),
        pill: target.querySelector('.featured-block__picture-column--pill .featured-block__picture-container'),
      },
    }

    const method = {
      init(): void {
        method.parallaxImages()
      },

      parallaxImages(): void {
        const isReversed = !!target.classList.contains('featured-block--images-left')

        const triggerParams = {
          end: 'clamp(100% 0%)',
          scrub: true,
          start: 'clamp(0% 100%)',
          trigger: el.block,
        }

        gsap.to(el.photo.circle, {
          scrollTrigger: triggerParams,
          y: isReversed ? '50%' : '-50%',
        })

        gsap.fromTo(
          el.photo.main.firstElementChild,
          {
            scale: 1.123,
          },
          {
            scrollTrigger: triggerParams,
            scale: 1,
          }
        )

        gsap.to(el.photo.pill, {
          scrollTrigger: triggerParams,
          y: isReversed ? '-40%' : '40%',
        })
      },
    }

    method.init()
  },
}

export default featuredBlock
